import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Analytics } from "@vercel/analytics/react";
import { SpeedInsights } from '@vercel/speed-insights/react';
import "./styles/style.css";
import Router from "./utils/Router";
import { UserInfo } from "./utils/UserData";
import Header from "./components/Header";
import ScrollIndicator from "./components/ScrollIndicator";
import Footer from "./components/Footer";
import ReactGA from "react-ga4";

// Initialize GA once
if (process.env.NODE_ENV === "production") {
  ReactGA.initialize("G-ZED7ZDHF41");
}

function usePageTracking() {
  const location = useLocation();

  useEffect(() => {
    if (process.env.NODE_ENV === "production") {
      ReactGA.send({ hitType: "pageview", page: location.pathname + location.search });
    }
  }, [location]);
}

export default function App() {
  usePageTracking();

  return (
    <>
      <Analytics />
      <SpeedInsights />
      <UserInfo>
        <ScrollIndicator />
        <Header />
        <Router />
        <Footer />
      </UserInfo>
    </>
  );
}
